import {CHECK_EXIST_CONTRACT_FACILITY,
    CONTRACT_PEROIDICALS,CREATE_CONTRACT_FACILTY_PERIODICAL,CONTRACT_FACILITY_DATA,UPDATE_CONTRACT_PERIODICAL,CHECK_IN_PROGRESS_PERIODICAL,DELETE_PERIODICAL_DATA,RESET_DRAG_PERIODICAL} from 'shared/actions/allocation_action';

function allocationReducer(state = {is_exist_contract_facility:[],contract_peridicals_data:[],allocation_response:[],contract_facilitys_data:[],is_working_count:[]}, action) {
    switch (action.type) {
      case CHECK_EXIST_CONTRACT_FACILITY:
        return Object.assign({}, state, {
            is_exist_contract_facility: action.is_exist_contract_facility
        })

        case CONTRACT_PEROIDICALS:
        return Object.assign({}, state, {
            contract_peridicals_data: action.contract_peridicals_data
        })

        case CREATE_CONTRACT_FACILTY_PERIODICAL:
        return Object.assign({}, state, {
            allocation_response: action.allocation_response
        })

        case CONTRACT_FACILITY_DATA:
        return Object.assign({}, state, {
            contract_facilitys_data: action.contract_facilitys_data
        })

        case UPDATE_CONTRACT_PERIODICAL:
        return Object.assign({}, state, {
            allocation_response: action.allocation_response
        })

        case CHECK_IN_PROGRESS_PERIODICAL:
        return Object.assign({}, state, {
            is_working_count: action.is_working_count
        })
        case DELETE_PERIODICAL_DATA:
        return Object.assign({}, state, {
            allocation_response: action.allocation_response
        })

        case RESET_DRAG_PERIODICAL:
        return Object.assign({}, state, {
            allocation_response: action.allocation_response
        })
        
        
        default:
      return state
    }
}

export default allocationReducer;


// WEBPACK FOOTER //
// ./src/shared/reducers/allocation_reducer.js